
import Visit from "./Visit";

export default function Day({ isDesktop, day, onToggleVisitActive }) {
	return (
		<div className="bg-white rounded-[10px] p-[10px]">
			<div className="spacer p-[5px]"></div>
			<div className={`grid gap-[20px] ${isDesktop ? 'grid-cols-6' : 'grid-cols-2'}`}>
				{day.visit_data_list.map(visit => (
					<Visit key={visit.id} dayId={day.id} visit={visit} onToggleVisitActive={onToggleVisitActive} />
				))}
			</div>
		</div>
	)
}
